import WithGASetup from '../WithGASetup';
import ResetConfirmation from './ResetConfirmation';

export default WithGASetup(ResetConfirmation);
